import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  toaster: {
    '& ol': {
      display: 'flex',
      justifyContent: 'center',
    },
  },
}));

export default useStyles;
